import React from 'react';
import Modal from "react-modal";
import { toastPromise } from '../Helpers/ToastMessage';
import Bubble from '../Helpers/Bubble';
import 'react-image-upload/dist/index.css';
import { useCompany, useContacts } from '../Store/storeFunctions';
import { getFunctions, httpsCallable } from "firebase/functions";
import TiptapEmailTemplate from '../Form/BuilderTools/TipTapEmailTemplate';

import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { FormikSelect, FormikTextAreaInput, FormikTextInput } from '../FormikFields';

const GREY = '#CCC';
const GREY_LIGHT = 'rgba(255, 255, 255, 0.4)';
const GREY_DIM = '#686868';

const functions = getFunctions();
const sendBulkEmail = httpsCallable(functions, "sendBulkEmail");

function SendAnEmailModal(props) {
  const [emailTemplate, setEmailTemplate] = React.useState("<p></p>");
  const [emailConfig, setEmailConfig] = React.useState({
    subject: ''
  });
  const [seed, setSeed] = React.useState(0);

  const company = useCompany();
  const contactStore = useContacts();

  const EmailSchema = Yup.object().shape({
    subject: Yup.string().required('Required')
  });

  function sendEmails(newEmailConfig){
    toastPromise(async () => {
      const sendContacts = contactStore.contacts.filter(c => props.contacts.includes(c.ID));

      var sendData = {
        companyId: company.companyData.code,
        contacts: sendContacts,
        subject: newEmailConfig.subject,
        toEmailField: "Email",
        messageBody: emailTemplate,
        interpolations: interpolationList()
      };

      await sendBulkEmail(sendData);
      
      setEmailConfig({
        toHeader: ''
      });

      setEmailTemplate("<p></p>");
      setSeed(seed+1);
    });
  }

  function renderContacts() {
    var list = props.contacts.map(c => {
      const contact = contactStore.contacts.find(sc => sc.ID == c);

      if (!contact) {
        return <li>Not found.</li>
      }

      return <li>{contact.FirstName} {contact.LastName} - {contact.PhoneNumber} - {contact.Email}</li>
    });

    return <ul>
      {list}
    </ul>
  }
  
  var interpolationList = React.useCallback((options) => {
    var query = options?.query;

    var interpolations = [
        { ID: "CompanyName", Label: "Company Data - Name" },
        { ID: "CompanyEmail", Label: "Company Data - Email" },
        { ID: "CompanyWebsite", Label: "Company Data - Website" },
        { ID: "CompanyPortal", Label: "Company Data - Portal" },
        { ID: "CompanyPhone", Label: "Company Data - Phone" },
        { ID: "CompanyAddress", Label: "Company Data - Address" },
        { ID: "IndividualFormLink", Label: "Individual - Form Link" },
        { ID: "BusinessFormLink", Label: "Business - Form Link" },
        { ID: "TrustFormLink", Label: "Trust - Form Link" },
        { ID: "FirstName", Label: "Contact - First Name" },
        { ID: "LastName", Label: "Contact - Last Name" },
        { ID: "Email", Label: "Contact - Email" },
        { ID: "PhoneNumber", Label: "Contact - Phone Number" }
    ];

    if (query) {
        return interpolations.filter(i => i.Label.toLowerCase().startsWith(query.toLowerCase()));
    }

    return interpolations;
  }, []);

  function showSendEmails() {
    // write a function that determines when to disable the send emails button.
    const hasContacts = props.contacts.length > 0;
    const hasEmailTemplate = emailTemplate.length > 0 && emailTemplate != "<p></p>";

    return hasContacts && hasEmailTemplate;
  }

  function render() {
    return (
      <Modal
        isOpen={true}
        onRequestClose={() => props.close()}
        contentLabel={`Quick Texts`}
        portalClassName="ContactModal"
      >
        <div className="ContactModalHeader">Send Email(s)</div>

        <div className="ContactModalContent" style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
          <div className="container" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <div className="row">
              <h3 style={{ display: 'inline-block' }}>Send Bulk Email(s)</h3>
              <hr />
            </div>
            
            <Bubble width={300} below={true} left={true} helpText="Send an email to all of the contacts listed here. All contacts with an email in the list will be sent the same message." style={{ position: 'absolute', right: 0 }} />
            
            <h5>Recipients</h5>
            <div className='row' style={{ paddingLeft: 24 }}>
              { renderContacts() }
            </div>

            <div className='row'>
              <div className="col-12">
                <Formik
                  initialValues={emailConfig}
                  validationSchema={EmailSchema}
                  onSubmit={values => {
                    // same shape as initial values
                    setEmailConfig(values);
                    sendEmails(values);
                  }}
                >
                  {({ errors, touched }) => (
                    <Form>
                      <Field errors={errors} name="subject" component={FormikTextInput} formiklabel="Subject" />
                      
                      <div>
                        <div>Email Content</div>
                        <TiptapEmailTemplate itemResource={interpolationList} seed={seed} value={emailTemplate} setValue={(v) => setEmailTemplate(v)} />
                      </div>

                      <div className="mb-3 mt-3 center"> 
                        <button className="btn btn-sm btn-primary" type="submit" disabled={!showSendEmails()}>Send Email(s)</button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }

  return render();
}

const styles = {
  taxicons: {
    width: '100%',
    marginTop: '20%'
  },
  zone: {
    alignItems: 'center',
    border: `2px dashed ${GREY}`,
    borderRadius: 20,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
    padding: 20,
  },
  file: {
    background: 'linear-gradient(to bottom, #EEE, #DDD)',
    borderRadius: 20,
    display: 'flex',
    height: 120,
    width: 120,
    position: 'relative',
    zIndex: 10,
    flexDirection: 'column',
    justifyContent: 'center',
  },
  info: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: 10,
    paddingRight: 10,
  },
  size: {
    backgroundColor: GREY_LIGHT,
    borderRadius: 3,
    marginBottom: '0.5em',
    justifyContent: 'center',
    display: 'flex',
  },
  name: {
    backgroundColor: GREY_LIGHT,
    borderRadius: 3,
    fontSize: 12,
    marginBottom: '0.5em',
  },
  progressBar: {
    bottom: 14,
    position: 'absolute',
    width: '100%',
    paddingLeft: 10,
    paddingRight: 10,
  },
  zoneHover: {
    borderColor: GREY_DIM,
  },
  default: {
    borderColor: GREY,
  },
  remove: {
    height: 23,
    position: 'absolute',
    right: 6,
    top: 6,
    width: 23,
  },
}

export default SendAnEmailModal;